import { render, staticRenderFns } from "./BotAvatar.vue?vue&type=template&id=a0994c78"
import script from "./BotAvatar.vue?vue&type=script&lang=js"
export * from "./BotAvatar.vue?vue&type=script&lang=js"
import style0 from "./BotAvatar.vue?vue&type=style&index=0&id=a0994c78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports